module.exports = __webpack_public_path__ + "img/icon_product_material.8d48983.png";